import { useAppUsersContext } from 'features/users/AppUsers/useAppUsersContext'

export function useAppUsersContentState() {
    const { pane } = useAppUsersContext()

    return {
        pane,
    }
}
